import {
  GET_REGIONAL_PROVIDER,
  GET_REGIONAL_PROVIDER_ERROR,
  GET_REGIONAL_PROVIDER_SUCCESS,
  GET_REGIONAL_PROVIDERS,
  GET_REGIONAL_PROVIDERS_ERROR,
  GET_REGIONAL_PROVIDERS_SUCCESS
} from './RegionalProvidersSection.actions'

const regionalProvidersSectionState = {
  error: null,
  loading: false,
  provider: {
    amount: 0,
    amountUSD: 0,
    biddings: 0,
    bubble: [],
    bubbleCsv: [],
    orders: 0,
    percentage: 0,
    pie: [],
    pieCsv: [],
    totalAmount: 0,
    totalAmountUSD: 0
  },
  providers: {
    data: [],
    page: 1,
    pages: 1,
    records: 1
  }
}

/**
 * The regional providers section's reducer.
 */
const regionalProvidersSectionReducer = (state = regionalProvidersSectionState, { payload, type }) => {
  switch (type) {
    case GET_REGIONAL_PROVIDER:
    case GET_REGIONAL_PROVIDERS: {
      return { ...state, loading: true }
    }
    case GET_REGIONAL_PROVIDER_ERROR:
    case GET_REGIONAL_PROVIDERS_ERROR: {
      return { ...state, error: payload.error, loading: false }
    }
    case GET_REGIONAL_PROVIDER_SUCCESS: {
      return { ...state, loading: false, provider: { ...state.provider, ...payload } }
    }
    case GET_REGIONAL_PROVIDERS_SUCCESS: {
      return { ...state, loading: false, providers: { ...state.providers, ...payload } }
    }
    default: {
      return state
    }
  }
}

export default regionalProvidersSectionReducer
